import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiFolderPickerComponent } from '@components/ui-folder-picker/ui-folder-picker.component';
import { UiFolderTreeModalModule } from '@components/ui-folder-tree-modal/ui-folder-tree-modal.module';
import { SharedModule } from '@modules';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    declarations: [
        UiFolderPickerComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        UiFolderTreeModalModule,
        UiNgLetModule,
    ],
    exports: [
        UiFolderPickerComponent,
    ],
})
export class UiFolderPickerModule { }
